import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { ARCreditApplicationTargetParametersDto } from './ar-credit-application-target-parameters-dto';

export class ARPostCreditApplicationParametersDto {
    communityId: number;
    managementCompanyId: number;
    sourceId: number;
    sourceType: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    applyDate: Date; // Required

    @Type(() => ARCreditApplicationTargetParametersDto)
    targets: ARCreditApplicationTargetParametersDto[];
}
